export function initMenuMobile(){
    const menuStart = document.querySelector('.mobile-menu__catalog') as HTMLElement | null;
    if (!menuStart) return;

    const toggleBtn = menuStart.querySelector('.mobile-menu__catalog-trigger') as HTMLElement | null;
    if (!toggleBtn) return;

    // Клик по кнопке — toggle
    toggleBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        menuStart.classList.toggle('active');
    });

    // Клики вне меню — закрываем
    document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        if (!menuStart.contains(target)) {
            menuStart.classList.remove('active');
        }
    });
}